import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";
    var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0)
      generalSvc.logoutUser(enetsecure);

    if (dataSvc.currentExamIndex == -1)
      generalSvc.loginUser();

      if(dataSvc != null && dataSvc !== undefined){
        var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
        if(usersLanguage != null){
          translate.setDefaultLang(usersLanguage);
          translate.use(usersLanguage);
        }
        else{
          translate.setDefaultLang('en');
          translate.use('en');
        }
      }
      else{
        translate.setDefaultLang('en');
        translate.use('en');
      }
  }

  ngOnInit() {
    //this.displayQuestionFeedback();
    this.displayQuestionFeedback();
    // this.displayResponseFeedback();
  }

  skipFeedback(){
    this.generalSvc.goToEnetassess();
  }

  displayResponseFeedback(){
    var tableString = "";
    var questions = this.dataSvc.getFeedbackResponses();
    if(questions != null){
      for(var i = 0; i < questions.length; i++){          
          var responses = questions[i].QuestionResponses;
          for(var j = 0; j < responses.length; j++){
            if(responses[j].Feedback == true){
              var qText = questions[i].Question.QuestionText.substring(0, 100);
              var rText = responses[j].Response.AnswerText.substring(0, 100);
              tableString += `<tr style='border-bottom:1px solid #AAA; padding:5px;'>
                <td style='width:50%;'>(` + questions[i].Question.OriginalId + `)` + this.translateText('three') + ` - ` + (i + 1) + qText +  this.translateText('four') + ` - `  + rText + `</td>      
                <td style='width:50%;'>
                  <textarea class='feedText' rows='2' style='width:90%;'></textarea>
                </td>  
              </tr>`;
            }     
          }             
      }
    }
    
    if(tableString != ""){
      tableString = "<tr><th>" + this.translateText("five") + "</th><th>" + this.translateText("two") + "</th></tr>" + tableString;
      document.getElementById("flaggedDataResponse").innerHTML = tableString;
    }
    else{
      document.getElementById("flaggedDataResponse").style.display = "none";
    }
  }

  displayQuestionFeedback(){
    var tableString = "";
    var questions = this.dataSvc.getFeedbackResponses();
    var float = this.dataSvc.currentUser.Language.Name == 'Arabic' ? 'right' : 'left';
    console.log(float);
    if(questions != null){
      for(var i = 0; i < questions.length; i++){ 
        if (questions[i].Feedback == true){
          var qText = questions[i].Question.QuestionText;
          qText = qText.replace(/<img[^>]*>/g,"");
          if(float == 'right'){
            if(qText.indexOf("<table") >= -1){
              qText = qText.replace("<table ","<table dir='ltr' style='float:right;clear:both;width:100%'");
            }
            if(qText.indexOf("id=\"answerArea\"") >= -1){
              qText = qText.replace("id=\"answerArea\"", "id=\"answerArea\" style=\"clear:both;float:right\"");
            }
            if(qText.indexOf("id=\"questionHelp\"") >= -1){
              qText = qText.replace("id=\"questionHelp\"", "id=\"questionHelp\" style=\"clear:both;float:right\"");
            }
          }
          var questionString = "(" + questions[i].Question.OriginalId + ") " + this.translateText('three') + " " + (i + 1) + qText + this.translateText('four') + " - <br/>";

          var responses = questions[i].QuestionResponses;
          for(var j = 0; j < responses.length; j++){
            if(responses[j].Feedback == true){
              var rText = responses[j].Response.AnswerText;
              questionString += rText;
            }
          }

          if(float == "right"){
            tableString += `<tr style='border-top: 1px solid #AAA'>
                                <td style='width:50%;padding: 5px 20px;text-align:right;float:right;'>
                                  <textarea class='feedText' rows='5' dir='rtl' style='width:90%;' questionId='`+ questions[i].Question.OriginalId +`'></textarea>
                                </td> 
                                <td style='width:50%; padding: 5px 20px;clear:both; text-align:right;float:right;' dir='rtl'>` + questionString + `</td>      
                                 
                            </tr>`; 
          }
          else{
            tableString += `<tr style='border-top: 1px solid #AAA'>
                              <td style='width:50%; padding: 5px 20px; float:` + float + `;'>` + questionString + `</td>      
                              <td style='width:50%; padding: 5px 20px;'>
                                <textarea class='feedText' rows='5' style='width:90%;' questionId='`+ questions[i].Question.OriginalId +`'></textarea>
                              </td>  
                          </tr>`; 
          }
        }                               
      }
    }
    
    if(tableString != ""){
      if (float == "right"){
        tableString = "<tr><th style='text-align:" + float +";'>" + this.translateText("two") + "</th><th style='text-align:" + float +";'>" + this.translateText("one") + "</th></tr>" + tableString;
      }
      else {
        tableString = "<tr><th>" + this.translateText("one") + "</th><th>" + this.translateText("two") + "</th></tr>" + tableString;
      }
      document.getElementById("flaggedData").innerHTML = tableString;
    }
    else{
      document.getElementById("flaggedData").style.display = "none";
    }
  }

  translateText(text){
    var language = this.dataSvc.currentUser.Language.Name;
    console.log(language);
    if(language == "Arabic"){
      if(text == "one"){
        return "السؤال (الأسئلة) الذي وضعت علامة عليه للمراجعة";
      }
      else if(text == "two"){
        return "التعليق";
      }
      else if(text == "three"){
        return "سؤال";
      }
      else if(text == "four"){
        return "استجابات";
      }
    }
    else if(language == "Azerbaijani"){
      if(text == "one"){
        return "Nəzərdən keçirilmə üçün işarələnmiş sual(lar)";
      }
      else if(text == "two"){
        return "Rəy";
      }
      else if(text == "three"){
        return "Sual";
      }
      else if(text == "four"){
        return "Cavablar";
      }
    }
    else if(language == "Chinese"){
      if(text == "one"){
        return "标记为审阅的问题";
      }
      else if(text == "two"){
        return "反馈";
      }
      else if(text == "three"){
        return "题";
      } 
      else if(text == "four"){
        return "回应";
      }
    }
    else if(language == "Croatian"){
      if(text == "one"){
        return "Pitanje/a označena za reviziju";
      }
      else if(text == "two"){
        return "Povratne informacije";
      }
      else if(text == "three"){
        return "Pitanje";
      }
      else if(text == "four"){
        return "Odgovori";
      }
    }
    else if(language == "Czech"){
      if(text == "one"){
        return "Jedna nebo více otázek označených k posouzení";
      }
      else if(text == "two"){
        return "Komentář";
      }
      else if(text == "three"){
        return "Otázka";
      }
      else if(text == "four"){
        return "Odpovědi";
      }
    }
    else if(language == "Dutch"){
      if(text == "one"){
        return "Vra(a)g(en) gemarkeerd voor beoordeling";
      }
      else if(text == "two"){
        return "Feedback";
      }
      else if(text == "three"){
        return "Vraag";
      }
      else if(text == "four"){
        return "Reacties";
      }
      
    }
    else if(language == "English"){
      if(text == "one"){
        console.log('1111');
        return "Question(s) Flagged for Review";
      }
      else if(text == "two"){
        return "Feedback";
      }
      else if(text == "three"){
        return "Question";
      }
      else if(text == "four"){
        return "Responses";
      }
    }
    else if(language == "French"){
      if(text == "one"){
        return "Question(s) balisée(s) pour examen";
      }
      else if(text == "two"){
        return "Commentaires";
      }
      else if(text == "three"){
        return "Question";
      }
      else if(text == "four"){
        return "Réponses";
      }
    }
    else if(language == "German"){
      if(text == "one"){
        return "Zur Überprüfung markierte Frage(n)";
      }
      else if(text == "two"){
        return "Feedback";
      }
      else if(text == "three"){
        return "Frage";
      }
      else if(text == "four"){
        return "Antworten";
      }
    }
    else if(language == "Hindi"){
      if(text == "one"){
        return "Question(s) Flagged for Review";
      }
      else if(text == "two"){
        return "Feedback";
      }
      
    }
    else if(language == "Hungarian"){
      if(text == "one"){
        return "Ellenőrzésre megjelölt kérdés(ek)";
      }
      else if(text == "two"){
        return "Visszajelzés";
      }
      else if(text == "three"){
        return "kérdés";
      }
      else if(text == "four"){
        return "Válaszok";
      }
    }
    else if(language == "Indonesian"){
      if(text == "one"){
        return "Question(s) Flagged for Review";
      }
      else if(text == "two"){
        return "Feedback";
      }
      
    }
    else if(language == "Italian"){
      if(text == "one"){
        return "Domanda/e segnalata/e per revisione";
      }
      else if(text == "two"){
        return "Feedback";
      }
      else if(text == "three"){
        return "Domanda";
      }
      else if(text == "four"){
        return "Risposte";
      }
    }
    else if(language == "Malay"){
      if(text == "one"){
        return "Question(s) Flagged for Review";
      }
      else if(text == "two"){
        return "Feedback";
      }
      
    }
    else if(language == "Norwegian"){
      if(text == "one"){
        return "Spørsmål flagget for gjennomgang";
      }
      else if(text == "two"){
        return "Tilbakemelding";
      }
      else if(text == "three"){
        return "Spørsmål";
      }
      else if(text == "four"){
        return "Svar";
      }
    }
    else if(language == "Polish"){
      if(text == "one"){
        return "Pytania zaznaczone do przeglądu";
      }
      else if(text == "two"){
        return "Informacja zwrotna";
      }
      else if(text == "three"){
        return "Pytanie";
      }
      else if(text == "four"){
        return "Odpowiedzi";
      }
    }
    else if(language == "Portuguese"){
      if(text == "one"){
        return "Pergunta(s) sinalizada(s) para revisão";
      }
      else if(text == "two"){
        return "Comentário";
      }
      
    }
    else if(language == "Portuguese Brazilian"){
      if(text == "one"){
        return "Pergunta(s) sinalizada(s) para revisão";
      }
      else if(text == "two"){
        return "Comentário";
      }
      else if(text == "three"){
        return "Pergunta";
      }
      else if(text == "four"){
        return "Respostas";
      }
    }
    else if(language == "Romanian"){
      if(text == "one"){
        return "Întrebare(ări) marcată(e) pentru analiză";
      }
      else if(text == "two"){
        return "Feedback";
      }    
      else if(text == "three"){
        return "Întrebarea";
      }  
      else if(text == "four"){
        return "Răspunsuri";
      }
    }
    else if(language == "Russian"){
      if(text == "one"){
        return "Вопрос(-ы), отмеченный(-е) для пересмотра";
      }
      else if(text == "two"){
        return "Комментарий";
      }
      else if(text == "three"){
        return "Вопрос";
      } 
      else if(text == "four"){
        return "Ответы";
      }
    }
    else if(language == "Spanish"){
      if(text == "one"){
        return "Preguntas marcadas para la revisión";
      }
      else if(text == "two"){
        return "Comentarios";
      }
      else if(text == "three"){
        return "Pregunta";
      } 
      else if(text == "four"){
        return "Respuestas";
      }
    }
    else if(language == "Spanish South American"){
      if(text == "one"){
        return "Preguntas marcadas para la revisión";
      }
      else if(text == "two"){
        return "Comentarios";
      }
      
    }
    else if(language == "Thai"){
      if(text == "one"){
        return "คำถามที่ทำเครื่องหมายไว้สำหรับการทบทวน";
      }
      else if(text == "two"){
        return "ข้อเสนอแนะ";
      }
      else if(text == "three"){
        return "คำถามที่";
      }
      else if(text == "four"){
        return "การตอบสนอง";
      }
    }
    else if(language == "Turkish"){
      if(text == "one"){
        return "Gözden geçirilmek üzere İşaretlenmiş Soru(lar)";
      }
      else if(text == "two"){
        return "Geri Bildirim";
      }    
      else if(text == "three"){
        return "Soru";
      }  
      else if(text == "four"){
        return "Tepkiler";
      }
    }
    else{
      if(text == "one"){
        return "Question(s) Flagged for Review";
      }
      else if(text == "two"){
        return "Feedback";
      }
      else if(text == "three"){
        return "Question";
      }
      else if(text == "four"){
        return "Responses";
      }
    }
  }

  submitFeedback(){
    var textareas = document.querySelectorAll("textarea");
    //console.log(textareas);
    var overallFeedback = "";
    for (let i = 0; i < textareas.length; ++i)
    {
      var textArea = textareas[i];
      var title = textArea.getAttribute("questionId");
      var value = textArea.value.toString();

      if (title.length > 0 && value.length > 0)
      {
        if (overallFeedback != "")
          overallFeedback += "<br/>";

        if (i+1 == textareas.length)
          overallFeedback += "<br/>";

        overallFeedback += title + " - " + value;
      }
    }
    //console.log(overallFeedback);
    
    if(overallFeedback !== "")
    {
      overallFeedback = overallFeedback.replace("'", "");  
      this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.Feedback = overallFeedback;
      var sessionId = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.SessionId;
      this.dataSvc.submitFeedback(sessionId, overallFeedback);
    }    
  }
}
